import { render, staticRenderFns } from "./contractor.vue?vue&type=template&id=54f1bb96&"
import script from "./contractor.vue?vue&type=script&lang=js&"
export * from "./contractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports